export const SET_MASTER = 'SET_MASTER'
